// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n[data-v-3ab0e0ef]#search .input-group-text {\n  padding-left: 0;\n  padding-right: 0;\n}\n", ""]);
// Exports
module.exports = exports;
